export enum FiTaskListFilterType {
    All = 1,
    Completed = 2,
    InProgress = 3,
}
